import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { amountFormatter } from '../../utils/utils';
import { MimaButton } from '../Button';
import MimaText from '../MimaText';
import styles from './../../assets/styles/Admin/AdminProducts.module.scss';
import defaultProductImage from './../../assets/img/image-broken.png';
import TableSearch from '../MimaTable/TableSearch';
import PageLoader from '../PageLoader';
import Pagination from '../MimaTable/Pagination';
import EmptyState from './EmptyState';
import { adminStore } from '../../stores';

const ProductGridItem = ({ product }) => {
	const navigate = useNavigate();
	const { imageUrls, name, pricingModel, variations, _id } = product;
	const { setSelectedProduct } = adminStore;

	const firstVariation = variations?.[0];
	const isFixedPricing = pricingModel === 'FIXED_PRICE';
	const local = firstVariation?.sellingPrices
		.filter(x => x?.type === 'LOCAL')
		.map(x => x)[0];
	const rtw = amountFormatter(local?.currencyCode).format(local?.withMaterial);
	const international = firstVariation?.sellingPrices
		.filter(x => x?.type === 'INTERNATIONAL')
		.map(x => x)[0];
	const internantionalRtw = amountFormatter(international?.currencyCode).format(
		international?.withMaterial
	);
	const productImage = imageUrls?.[0]?.trim?.()
		? imageUrls[0]
		: defaultProductImage;

	return (
		<div className={styles.product}>
			<img
				src={productImage}
				alt="Style"
				onError={e => {
					e.currentTarget.onerror = null;
					e.currentTarget.src = defaultProductImage;
				}}
			/>
			<MimaText variant="bodyBold">{name}</MimaText>
			{isFixedPricing && (
				<div>
					Price / RTW: <MimaText variant="bodyBold">{rtw}</MimaText>
				</div>
			)}
			{isFixedPricing && international && (
				<div>
					International Price:{' '}
					<MimaText variant="bodyBold">{internantionalRtw}</MimaText>
				</div>
			)}

			<div className={styles.product__actions}>
				<MimaButton
					onClick={() => {
						setSelectedProduct(product);
						navigate(constant.Routes.Admin.SingleProduct.replace(':id', _id));
					}}
					title="View Details"
					variant="colorableSmall"
					buttonColor="var(--color-fash-black)"
				/>
				<MimaButton
					onClick={() => {
						setSelectedProduct(product);
						navigate(constant.Routes.Admin.EditProduct.replace(':id', _id));
					}}
					title="Edit Product"
					variant="colorableSmall"
					titleColor="var(--color-fash-black)"
					buttonColor="var(--color-fash-primary)"
				/>
			</div>
		</div>
	);
};
export const ProductGrid = ({
	products,
	hidePagination = false,
	hideSearch = false,
	totalItems,
	onLimitChange,
	isLoading,
	isFetching,
	limit,
	currentPage,
	setCurrentPage,
	setSearchQuery,
	searchPlaceholder,
	emptyMessage = 'No products found',
}) => {
	const navigate = useNavigate();
	return (
		<>
			{!hideSearch && (
				<div className="searchInMiddle">
					<TableSearch
						// filter={globalFilter}
						// setFilter={setGlobalFilter}
						placeholder={searchPlaceholder}
						variant="wide"
						setSearchQuery={setSearchQuery}
						mb={2}
					/>
				</div>
			)}

			{isLoading ? (
				<PageLoader loading={isLoading} title="while we fetch your data" />
			) : (
				<>
					{products?.length ? (
						<div className={styles.product__grid}>
							{products.map((product, i) => (
								<ProductGridItem product={product} key={i} />
							))}
						</div>
					) : (
						<EmptyState
							text={emptyMessage}
							subText="Try adjusting your search or add a new product."
							buttonTitle="Add Product"
							onButtonClick={() => {
								navigate(constant.Routes.Admin.AddProduct);
							}}
						/>
					)}
				</>
			)}
			{isFetching && <PageLoader loading={isFetching} type="bar" />}
			{!hidePagination && (
				<Pagination
					limit={limit}
					onLimitChange={onLimitChange}
					totalItems={totalItems}
					pageCount={Math.ceil(totalItems / limit)}
					currentPage={currentPage}
					setCurrentPage={setCurrentPage}
				/>
			)}
		</>
	);
};

export default ProductGrid;
